<template>
  <div class="baniere">
    <div class="bloc flex flex md:pt-20 pt-10">
      <div class="md:w-3/5 md:pt-10">
        <div
          class="title w-full md:mt-6"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          Solutions de santé
        </div>

        <div class="flex">
          <div
            class="text-white blocc md:p-12 p-6"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div class="titre1">
              Healthcore by 41DEVS
            </div>
            <div class="detail md:mt-6 mt-2">
              Nous mettons à  disposition une suite de solutions technologiques pour des soins sanitaires  personnalisés et pour améliorer la collaboration au sein des équipes de soins.
            </div>
          </div>
        </div>
      </div>
      <div class="md:w-2/5 text-right">
        <img
          src="../../../assets/icons/ic_arc.svg"
          alt=""
          data-aos="fade-left"
          data-aos-duration="2000"
        >
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   max-height: 530px;
   background-color: $background-gray-dev;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: white;
  }
  .title{
    font-style: normal;
    font-weight: 800;
    font-size: 64px;
    line-height: 150%;
    color: $black;
  }
  .titre1{
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
  }
  .detail{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
  }
.blocc{
  background-color: $devs_color;
  z-index: 1;
  width: 75%;
}
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
      height: auto;
    }
    .title{
      font-size: 36px;
      line-height: 170%;
    }
    .bloc{
      flex-direction: column-reverse;
    }
    .blocc{
      width: 100%;
      font-size: 18px;
    }
    .titre{
      font-size: 28px;
    }
    .titre1{
      font-size: 26px;
    }
    .detail{
      font-size: 18px;
    }
    img{
      height: 180px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
      height: 490px;
    }
    .title{
      font-size: 60px;
    }
    .titre1{
      font-weight: bold;
      font-size: 30px;
      line-height: 43px;
    }
    .detail{
      font-weight: normal;
      font-size: 20px;
      line-height: 160%;
    }
    .blocc {
      padding: 30px;
    }
  }
</style>
